<template>
  <div>
    <div class="month" v-for="month in getMonths()" :key="month">
      <h3 class="title is-4">{{ months[month] }}</h3>
      <div class="list">
        <a
          class="panel-block"
          v-for="course in getCourseForMonth(month)"
          :key="course._id"
          @click="selectCourse(course)"
          :class="{
            disabled: course.numberOfBookings == course.numberOfParticipants,
          }"
        >
          {{ course.type }}
          <br />
          {{ course.startDate | formatDateDay }} -
          {{ course.endDate | formatDateDay }} | {{ course.time }}
          <p class="nbr">
            Platser:
            {{ course.numberOfParticipants - course.numberOfBookings }}/{{
              course.numberOfParticipants
            }}
            <br />
            <span v-if="showPrice">
              Pris: {{ course.price }} kr
            </span>
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";
import router from "@/router.js";
export default {
  name: "CourseListPublic",
  data: function () {
    return {
      showPrice: true,
      courses: [],
      months: [
        "Januari",
        "Februari",
        "Mars",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "Augusti",
        "September",
        "okt",
        "nov",
        "dec",
      ],
    };
  },
  created: function () {
    this.fetchCourses();
    this.getPriceSetting();
  },
  methods: {
    fetchCourses() {
      axios.get("/api/courses/").then((response) => {
        this.courses = response.data;
        var id = this.$route.query.id;
        if (id) {
          var course = this.courses.filter((course) => course._id == id)[0];
          this.$emit("courseSelected", course);
        }
      });
    },
    getMonths() {
      return [
        ...new Set(
          this.courses.map((course) => new Date(course.startDate).getMonth())
        ),
      ].sort();
    },
    getCourseForMonth(month) {
      return this.courses
        .filter((course) => new Date(course.startDate).getMonth() == month)
        .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    },
    selectCourse: function (course) {
      router.push({ path: "book", query: { id: course._id } });
    },
    getPriceSetting: function () {
      axios.get("/api/settings/showprice").then((response) => {
        this.showPrice = response.data;
      });
    }
  },
  watch: {
    $route(to) {
      var id = to.query.id;
      if (id) {
        var course = this.courses.filter((course) => course._id == id)[0];
        this.$emit("courseSelected", course);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.disabled {
  pointer-events: none;
  background: #f8f8f8;
  opacity: 0.4;
}

.course-container {
  text-align: left;
  padding: 15px;
}

.month {
  margin-bottom: 20px;
}

.nbr {
  margin-left: auto;
}

.list {
  box-shadow: none !important;
}

</style>